module.exports = __webpack_public_path__ + "img/mswi.9dd6937a.svg";